import React from "react";

const Modal = ({ isOpen, closeModal, children,width }) => {
  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div
            className="fixed inset-0 bg-black opacity-50 z"
            onClick={closeModal}
          ></div>
          <div className={`bg-white z-50 ${width }  rounded-lg shadow-lg p-6  mx-auto animate-slide-down`}>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
